// import React from 'react';
// import { 
//   Box, 
//   Button, 
//   Typography, 
//   Paper, 
//   useMediaQuery,
//   List,
//   ListItem,
//   ListItemText
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';

// const RefundPolicy = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         py: 3,
//        backgroundColor: 'rgb(239, 231, 221)',
//         backgroundImage: 'url(https://www.transparenttextures.com/patterns/cream-paper.png)',
//         backgroundRepeat: 'repeat'
//       }}
//     >
//       <Paper
//         elevation={3}
//         sx={{
//           width: '100%',
//           maxWidth: 900,
//           height: isMobile ? '90vh' : '80vh',
//           display: 'flex',
//           flexDirection: 'column',
//           borderRadius: 2,
//           overflow: 'hidden',
//           //backgroundColor: 'rgba(239, 231, 221, 0.9)'
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             p: 2,
//             position: 'sticky',
//             top: 0,
//             backgroundColor: 'inherit',
//             zIndex: 1,
//             borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
//           }}
//         >
//           <Typography variant="h6" fontWeight="bold">
//             Refund Policy
//           </Typography>
//         </Box>

//         {/* Scrollable Content */}
//         <Box
//           sx={{
//             overflowY: 'auto',
//             flex: 1,
//             px: 3,
//             pt: 2,
//             pb: 1
//           }}
//         >
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
//             1. Overview
//           </Typography>
//           <Typography variant="body2" paragraph>
//             At Property Pincoder, we strive to provide excellent service and ensure customer satisfaction...
//           </Typography>

//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
//             2. Eligibility for Refunds
//           </Typography>
//           <List dense>
//             <ListItem>
//               <ListItemText primary="Refunds may be considered only for payments made for premium services..." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="Requests must be submitted within 30 days from the date of payment." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="Refunds are not provided for transactions related to property purchases..." />
//             </ListItem>
//           </List>

//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
//             3. Process for Requesting Refunds
//           </Typography>
//           <Typography variant="body2" paragraph>
//             To request a refund, contact our customer support team...
//           </Typography>

//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
//             4. Refund Approval and Processing
//           </Typography>
//           <List dense>
//             <ListItem>
//               <ListItemText primary="Refund processed within 7-10 business days upon approval." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="Refunds through the original mode of payment where possible." />
//             </ListItem>
//           </List>

//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
//             5. Non-Refundable Items
//           </Typography>
//           <List dense>
//             <ListItem>
//               <ListItemText primary="Third-party service charges and government fees." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="Fees paid to brokers, vendors, etc." />
//             </ListItem>
//           </List>

//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
//             6. Cancellation Policy
//           </Typography>
//           <Typography variant="body2" paragraph>
//             Paid services may be canceled before being rendered. Refunds are subject to policy terms.
//           </Typography>

//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
//             7. Changes to Refund Policy
//           </Typography>
//           <Typography variant="body2" paragraph>
//             Policy updates may be made at any time and will be notified via email or app.
//           </Typography>

//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
//             8. Contact Information
//           </Typography>
//           <Typography variant="body2" paragraph>
//             For questions, contact our support team through the app or email.
//           </Typography>
//         </Box>

//         {/* Footer Buttons */}
//         <Box
//           sx={{
//             p: 2,
//             display: 'flex',
//             flexDirection: isMobile ? 'column' : 'row',
//             gap: 2,
//             borderTop: '1px solid rgba(0, 0, 0, 0.12)',
//             backgroundColor: 'inherit'
//           }}
//         >
//           <Button
//             variant="outlined"
//             fullWidth
//             onClick={() => navigate('/')}
//             sx={{
//               color: 'text.primary',
//               borderColor: 'text.primary',
//               '&:hover': {
//                 borderColor: 'text.primary',
//                 backgroundColor: 'rgba(0, 0, 0, 0.04)'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             fullWidth
//             onClick={() => navigate('/')}
//             sx={{
//               backgroundColor: 'text.primary',
//               color: 'background.paper',
//               '&:hover': {
//                 backgroundColor: 'rgba(0, 0, 0, 0.8)'
//               }
//             }}
//           >
//             I have read and accept the terms of service
//           </Button>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default RefundPolicy;



import React from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  useMediaQuery,
  Divider,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import CurrencyRupeeRoundedIcon from '@mui/icons-material/CurrencyRupeeRounded';

// ── Palette (matches PrivacyPolicy / TermsAndConditions) ──
const OUTER_BG = 'rgb(239, 231, 221)';
const CARD_BG = '#FFFDF8';
const BORDER = '#EFE6D6';
const TITLE_DARK = '#2B2118';
const SUBTLE = '#7A6A5A';
const ACCENT = '#8A6A3D';
const ACCENT_DARK = '#6B3620';

const RefundPolicy = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // ── Reusable Section ──
  const Section = ({ title, children }) => (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: '50%',
            bgcolor: '#F4E7CE',
            color: ACCENT_DARK,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            fontSize: '0.72rem',
            flexShrink: 0,
            border: '1px solid #E8D4A8',
          }}
        >
          §
        </Box>
        <Typography
          sx={{
            fontWeight: 800,
            color: TITLE_DARK,
            fontSize: '0.95rem',
            letterSpacing: 0.1,
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={{ pl: { xs: 0, sm: 4.5 } }}>{children}</Box>
    </Box>
  );

  // ── Reusable bullet ──
  const Bullet = ({ children }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.5 }}>
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          bgcolor: ACCENT,
          mt: '7px',
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{
          fontSize: '0.82rem',
          color: TITLE_DARK,
          fontWeight: 600,
          lineHeight: 1.55,
        }}
      >
        {children}
      </Typography>
    </Box>
  );

  const Para = ({ children, sx = {} }) => (
    <Typography
      sx={{
        fontSize: '0.82rem',
        color: SUBTLE,
        lineHeight: 1.6,
        mb: 1.2,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: OUTER_BG,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: { xs: 2, sm: 4 },
        px: { xs: 1.5, sm: 2 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 900,
          display: 'flex',
          flexDirection: 'column',
          height: isMobile ? '92vh' : '85vh',
          borderRadius: '20px',
          overflow: 'hidden',
          background: CARD_BG,
          border: `1px solid ${BORDER}`,
          boxShadow: '0 10px 30px rgba(0,0,0,0.10)',
        }}
      >
        {/* ===== HEADER ===== */}
        <Box
          sx={{
            px: { xs: 2, sm: 3 },
            py: 2,
            position: 'sticky',
            top: 0,
            backgroundColor: CARD_BG,
            zIndex: 10,
            borderBottom: `1px solid ${BORDER}`,
            display: 'flex',
            alignItems: 'center',
            gap: 1.2,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: '#F4E7CE',
              color: ACCENT_DARK,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              border: '1px solid #E8D4A8',
            }}
          >
            <CurrencyRupeeRoundedIcon sx={{ fontSize: 22 }} />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: { xs: '0.95rem', sm: '1.1rem' },
                color: TITLE_DARK,
                lineHeight: 1.2,
              }}
            >
              Refund Policy
            </Typography>
            <Typography
              sx={{
                fontSize: '0.72rem',
                color: SUBTLE,
                fontWeight: 600,
                mt: 0.2,
              }}
            >
              PropertyPincoder · Effective {new Date().toLocaleDateString()}
            </Typography>
          </Box>

          <Box
            sx={{
              bgcolor: '#F4E7CE',
              color: ACCENT_DARK,
              fontWeight: 700,
              fontSize: '0.68rem',
              px: 1,
              py: 0.3,
              height: 22,
              borderRadius: '999px',
              border: '1px solid #E8D4A8',
              display: { xs: 'none', sm: 'inline-flex' },
              alignItems: 'center',
            }}
          >
            v1.0
          </Box>
        </Box>

        {/* ===== SCROLLABLE CONTENT ===== */}
        <Box
          sx={{
            overflowY: 'auto',
            px: { xs: 2, sm: 3 },
            py: 2.5,
            flex: 1,
            '&::-webkit-scrollbar': { width: 6 },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#D8C7AA',
              borderRadius: 3,
            },
            '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
          }}
        >
          {/* 1. Overview */}
          <Section title="1. Overview">
            <Para>
              At Property Pincoder, we strive to provide excellent service and ensure
              customer satisfaction. This Refund Policy outlines the terms under which
              refunds may be requested and processed for services availed through our
              platform. Please read this policy carefully before making any payment.
            </Para>
          </Section>

          <Divider sx={{ my: 2, borderColor: BORDER }} />

          {/* 2. Eligibility for Refunds */}
          <Section title="2. Eligibility for Refunds">
            <Bullet>
              Refunds may be considered only for payments made for premium services, and
              only when the service has not been substantially delivered.
            </Bullet>
            <Bullet>
              Requests must be submitted within 30 days from the date of payment.
            </Bullet>
            <Bullet>
              Refunds are not provided for transactions related to property purchases,
              token amounts, or advance payments made directly to sellers, builders, or
              landlords.
            </Bullet>
          </Section>

          <Divider sx={{ my: 2, borderColor: BORDER }} />

          {/* 3. Process for Requesting Refunds */}
          <Section title="3. Process for Requesting Refunds">
            <Para>
              To request a refund, contact our customer support team through the app or
              via email with your Order ID, payment receipt, and the reason for the refund
              request. Our team will review the request and respond within a reasonable
              time frame.
            </Para>
          </Section>

          <Divider sx={{ my: 2, borderColor: BORDER }} />

          {/* 4. Refund Approval and Processing */}
          <Section title="4. Refund Approval and Processing">
            <Bullet>
              Refund processed within 7-10 business days upon approval.
            </Bullet>
            <Bullet>
              Refunds through the original mode of payment where possible.
            </Bullet>
          </Section>

          <Divider sx={{ my: 2, borderColor: BORDER }} />

          {/* 5. Non-Refundable Items */}
          <Section title="5. Non-Refundable Items">
            <Bullet>Third-party service charges and government fees.</Bullet>
            <Bullet>Fees paid to brokers, vendors, etc.</Bullet>
          </Section>

          <Divider sx={{ my: 2, borderColor: BORDER }} />

          {/* 6. Cancellation Policy */}
          <Section title="6. Cancellation Policy">
            <Para>
              Paid services may be canceled before being rendered. Refunds are subject to
              policy terms.
            </Para>
          </Section>

          <Divider sx={{ my: 2, borderColor: BORDER }} />

          {/* 7. Changes to Refund Policy */}
          <Section title="7. Changes to Refund Policy">
            <Para>
              Policy updates may be made at any time and will be notified via email or
              app.
            </Para>
          </Section>

          <Divider sx={{ my: 2, borderColor: BORDER }} />

          {/* 8. Contact Information */}
          <Section title="8. Contact Information">
            <Para>
              For questions, contact our support team through the app or email.
            </Para>
          </Section>
        </Box>

        {/* ===== FOOTER ===== */}
        <Box
          sx={{
            px: { xs: 2, sm: 3 },
            py: 2,
            borderTop: `1px solid ${BORDER}`,
            backgroundColor: CARD_BG,
            display: 'flex',
            flexDirection: { xs: 'column-reverse', sm: 'row' },
            gap: 1.2,
          }}
        >
          <Button
            variant="outlined"
            fullWidth
            onClick={() => navigate('/')}
            sx={{
              borderColor: '#D8C7AA',
              color: ACCENT_DARK,
              fontWeight: 700,
              textTransform: 'none',
              borderRadius: '10px',
              py: 1.1,
              '&:hover': {
                borderColor: ACCENT,
                backgroundColor: '#FBF4E8',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={() => navigate('/')}
            sx={{
              backgroundColor: ACCENT_DARK,
              color: '#FFFFFF',
              fontWeight: 700,
              textTransform: 'none',
              borderRadius: '10px',
              py: 1.1,
              boxShadow: '0 4px 12px rgba(107,54,32,0.25)',
              '&:hover': {
                backgroundColor: '#5A2C1A',
                boxShadow: '0 6px 16px rgba(107,54,32,0.35)',
              },
            }}
          >
            I have read and accept the terms of service
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default RefundPolicy;